import { controls } from "../controls";

const ms64 = {
  label: "Allowance Master",
  pageLabel: "Allowance Master",
  starting: true,
  url: "ms64",
  bulk: { columns: ['code', 'sub_group_of','short_name','namae','regional_name','calculation_type','allowance_type','gl_display','above_amount','priority_for_deduction'] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Allowance",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "allowance", width: "col-sm-4", placeHolder: "code" }),

    ...controls.displayText({ tab: "filter", label: "Calculation Type",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "calculation_type", width: "col-sm-4", placeHolder: "Calculation Type" }),

    ...controls.displayText({ tab: "filter", label: "Name",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "name", width: "col-sm-4", placeHolder: "Name" }),

    ...controls.displayText({ tab: "Modal", label: "Number Of Record", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "Modal", name: "number_of_record", width: "col-sm-4", placeHolder: "Number Of Record" }),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.checkBox({ tab: "filter", label: "Active", name: "Active", width: "col-sm-2"}),
   
  ],
  form: [
    ...controls.displayText({ tab: "filter", label: "Code",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "code", width: "col-sm-4", placeHolder: "code" }),

    ...controls.displayText({ tab: "filter", label: "Sub Group Of",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "sub_group_of", width: "col-sm-4", placeHolder: "Sub Group Of" }),

    ...controls.displayText({ tab: "filter", label: "Short Name",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "short_name", width: "col-sm-4", placeHolder: "Short Name" }),
 
    ...controls.displayText({ tab: "filter", label: "Name",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "name", width: "col-sm-4", placeHolder: "Name" }),

    ...controls.displayText({ tab: "filter", label: "Regional Name",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "regional_name", width: "col-sm-4", placeHolder: "Regional Name" }),

    ...controls.displayText({ tab: "filter", label: "Calculation Type",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "calculation_type", width: "col-sm-4", placeHolder: "Calculation Type" }),

    ...controls.displayText({ tab: "filter", label: "Allowance Type",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "allowance_type", width: "col-sm-4", placeHolder: "Allowance Type" }),

    ...controls.displayText({tab:"filter",label: "General Ledger",star:true,width:"col-sm-2"}),
    ...controls.GL({tab: "Modal"}),
    ...controls.showData({tab:"filter",data: "gl_display", name: "gl_display",width:"col-sm-2"}),

    ...controls.displayText({ tab: "filter", label: "Above Amount",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "above_amount", width: "col-sm-4", placeHolder: "Above Amount" }),

    ...controls.displayText({ tab: "filter", label: "Priority For Deduction ",star:true, width: "col-sm-2" }),
    ...controls.text({ tab: "filter",isRequired:true, name: "priority_for_deduction", width: "col-sm-4", placeHolder: "Priority For Deduction" }),



    ...controls.checkBox({ tab: "filter", label: "Tax Applicable", name: "Tax_Applicable", width: "col-sm-2"}),
    
    ...controls.checkBox({ tab: "filter", label: "Applicable For Leave Salary", name: "Applicable_For_Leave_Salary", width: "col-sm-2"}),
    
    ...controls.checkBox({ tab: "filter", label: "Applicable For Festival Exgratia", name: "Applicable_For_Leave_Salary", width: "col-sm-2"}),

    ...controls.checkBox({ tab: "filter", label: "Active", name: "Active", width: "col-sm-2"}),



  ],

  history: {
    perPage: 10,
    reportHeader: "Allowance Master",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Edit",
        accessor: "edit",
      },
      {
        Header: "Delete",
        accessor: "delete",
      },

      {
        Header: "Code",
        accessor: "code",
      },
 
      {
        Header: "ALLWDEDU",
        accessor: "allwdedu",
      },

      {
        Header: "Name",
        accessor: "name",
      },

      {
        Header: "Calcu Type",
        accessor: "calcu_type",
      },

      {
        Header: "Allw Type",
        accessor: "alle_type",
      },

      {
        Header: "Active",
        accessor: "active",
      },

      {
        Header: "Entry By",
        accessor: "entry_by",
      },

      {
        Header: "Entry Date",
        accessor: "entry_date",
      },


      {
        Header: "Entry Time",
        accessor: "entry_time",
      },






      
    ]
  }
};

export default ms64;